<template>
    <div class="payout-detail__content table-loto645">
        <div class="table-loto645-title">{{ getTranslatedText('breakdown of winnings') }}</div>
        <table>
            <tr>
                <th class="num">{{ getTranslatedText('correct numbers') }}</th>
                <th class="earnings">{{ getTranslatedText('earnings') }}</th>
            </tr>
            <tr v-for="(value, index) in listLotoPayouts.loto459" :key="index">
                <td class="cell">
                    <span>{{ value.numbersN }}</span>
                </td>
                <td v-if="value.xargs !== ''">
                    <span>{{
                        getTranslatedText(value.earnings, {
                            currency: $store.state.CURRENCY,
                        })
                    }}</span>
                </td>
                <td v-else>
                    <span>{{ getTranslatedText(value.earnings) }}</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import listLotoPayouts from '@/resources/data/payouts.json'
import { formatPrice } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    data() {
        return {
            listLotoPayouts,
        }
    },

    methods: {
        renderPrice(price) {
            let decimal = this.isPariMutuelLotto ? 2 : 0
            return formatPrice(price, decimal)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/payouts/_payout-detail.scss';
</style>
